import React, { useEffect } from "react";
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";
import MedicationList from "components/organisms/MedicationList";
import MedicationInfo from "components/organisms/MedicationInfo";
import { Drug, DrugProductLabel } from "common/models/types";
import { log, LogLevel } from "utils/LogUtil";

interface MedicationsTemplateProps {
  drugs: Drug[];
  selectedDrug: Drug | null;
  onSelectDrug: (drug: Drug) => void;
  onEditDrug?: () => void;
  onSearch?: (query: string) => void;
  // 무한 스크롤 관련 props
  hasMore?: boolean;
  isLoadingMore?: boolean;
  isLoadingLabels?: boolean;
  onLoadMore?: () => void;
  // 크롤링 후 라벨 로드 완료 핸들러
  onLabelsLoaded?: (labels: DrugProductLabel[], itemCode: string) => void;
}

// 페이지 레이아웃 스타일
const Container = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 100px);
  background-color: ${COLOR_SYSTEM.get("Gray")?.[10]};
`;

// 왼쪽 패널 스타일
const LeftPanel = styled.div`
  flex: 0 0 350px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

// 오른쪽 패널 스타일
const RightPanel = styled.div`
  flex: 1;
  height: 100%;
`;

const MedicationsTemplate: React.FC<MedicationsTemplateProps> = ({
  drugs,
  selectedDrug,
  onSelectDrug,
  onEditDrug,
  onSearch,
  hasMore,
  isLoadingMore,
  isLoadingLabels,
  onLoadMore,
  onLabelsLoaded,
}) => {
  // 디버깅을 위한 로깅
  useEffect(() => {
    log(LogLevel.VERBOSE, "MedicationsTemplate 렌더링:");
    log(LogLevel.VERBOSE, "- selectedDrug:", selectedDrug);
    if (selectedDrug) {
      log(LogLevel.VERBOSE, "선택된 약품:", selectedDrug);
      log(LogLevel.VERBOSE, "- selectedDrug.standardCode:", selectedDrug.standardCode);
      log(LogLevel.VERBOSE, "- selectedDrug.productLabels:", selectedDrug.productLabels);
    }
  }, [selectedDrug]);

  return (
    <Container>
      <LeftPanel>
        <MedicationList
          drugs={drugs}
          selectedDrug={selectedDrug}
          onSelectDrug={onSelectDrug}
          onSearch={onSearch}
          hasMore={hasMore}
          isLoadingMore={isLoadingMore}
          onLoadMore={onLoadMore}
        />
      </LeftPanel>
      <RightPanel>
        <MedicationInfo
          drug={selectedDrug}
          onEdit={onEditDrug}
          isLoading={isLoadingLabels}
          onLabelsLoaded={onLabelsLoaded}
        />
      </RightPanel>
    </Container>
  );
};

export default MedicationsTemplate;
